import { Toast } from 'vant';
class Utils {
    /**
     * 日期格式化
     * @param {*} format 
     * @param {*} date 
     * @returns 
     */
    dateFmt(format, date) {
        format = format || 'Y-m-d H:i:s';
        date = this.date(date);
        return format.replace(/[YmdHisu]/g, function(string) {
            switch (string) {
                case 'Y':
                    return date.getFullYear().toString();
                case 'm':
                    return (date.getMonth() + 1).toString().padStart(2, '0');
                case 'd':
                    return date.getDate().toString().padStart(2, '0');
                case 'H':
                    return date.getHours().toString().padStart(2, '0');
                case 'i':
                    return date.getMinutes().toString().padStart(2, '0');
                case 's':
                    return date.getSeconds().toString().padStart(2, '0');
                case 'u':
                    return date.getMilliseconds().toString().padStart(3, '0');
                default:
                    return string;
            }
        });
    }

    /**
     * 日期
     * @param {*} date 
     * @returns 
     */
    date(date) {
        if (Object.prototype.toString.call(date) != '[object Date]') {
            if (date) {
                if (typeof date == 'string') {
                    // 处理ios中 new Date - 分隔符不识别
                    date = date.replace(/[-.]/g, '/');
                }
                let temp = new Date(date);
                if (temp == 'Invalid Date') {
                    throw new Error('日期格式错误');
                } else {
                    date = temp;
                }
            } else {
                date = new Date();
            }
        }
        return date;
    }

    /**
     * 获取url中的参数
     * @param {*} key 
     * @returns 
     */
    getQuery(key) {
        let obj = {};
        let href = window.location.href;
        if (~href.indexOf('?')) {
            let query = href.substring(href.indexOf('?') + 1);
            let vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                let pair = vars[i].split("=");
                obj[pair[0]] = pair[1]
            }
        }
        return key ? obj[key] : obj;
    }

    /**
     * dataUrl 转 文件
     * @param {*} dataUrl 
     * @param {*} fileName 
     * @returns 
     */
    dataURLtoFile(dataUrl, fileName) {
        var arr = dataUrl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], fileName, { type: mime });
    }

    /**
     * 获取UUID
     */
    UUID() {
            return `${S4()}${S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`;
        }
        /**
         * 复制文本
         */
    async copy(text) {
        let target = document.createElement("p");
        target.innerHTML = text;
        document.body.appendChild(target);
        const rechage_range = document.createRange();
        rechage_range.selectNode(target);
        const rechage_selection = window.getSelection();
        if (rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
        rechage_selection.addRange(rechage_range);
        document.execCommand("Copy");
        Toast("复制成功");
        rechage_selection.removeAllRanges();
        target.remove();
    }

    download(url, filename) {
        var a = document.createElement('a');
        a.download = filename;
        a.href = url;
        document.body.appendChild(a);
        // a.click();
        // document.body.removeChild(a);
    }
}

function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

export default new Utils();